import { ButtonVariant, CellType, IButtonProps, ICallToActionProps } from '@amobee/component-library';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { TableConfigs, ToolBarConfigs } from 'src/app/common/components/data-table/data-table.component';

@Component({
  selector: 'campaign-sheet',
  templateUrl: './campaign-sheet.component.html',
  styleUrls: ['./campaign-sheet.component.scss']
})
export class CampaignSheetComponent implements OnInit {

  @Input() campaignDetail: any;
  @Input() open: boolean = false;
  @Output() close = new EventEmitter();

  okButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'OK',
    onClick: () => {
      this.open = false;
      this.close.emit();
    }
  };

  public searchNotFoundCallToAction: ICallToActionProps = {
    type: 'EmptySearchResults',
    title: 'No Results Found'
  };

  showContentLoading: boolean = false;
  tableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'id',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: true,
    showSummaryRow: false,
    stickyHeader: false,
    stickyColumnHeaders: false,
    enableStickyColumns: false,
    fetchStaticData: (params: any) => {
      this.showContentLoading = true;
      return this.campaignAdapter.getCampaignList(this.campaignDetail.advertiserId, this.campaignDetail.brandId, params).then((value) => {
        this.showContentLoading = false;
        return value;
      });

    },
    showCallToAction: true,
    callToActionProps: this.searchNotFoundCallToAction
  };

  columns: any[] = [
    {
      Header: 'Campaign Name',
      accessor: 'name',
      id: 'name',
      isRowActionColumn: true,
      cellType: CellType.LINK,
      onLinkClick: row => {
        this.showContentLoading = true;
        // creative api need brand id in campaign form, if brand id is not provided (ie, in single company list)
        // try to get brand id by plan
        if (!this.campaignDetail.brandId) {
          this.campaignAdapter.getCampaignData(row.original.id).then((cvo) => {
            return this.campaignAdapter.getPlan(cvo.planId).then((pcd) => {
              this.campaignAdapter.updateCBAId(pcd.customer_id, pcd.advertiser_id, pcd.brand_id);
              return this.router.navigate(['campaign/edit', row.original.id]);
            })
          }).catch((e) => {
            console.error(e);
            this.showContentLoading = false;
          });
        } else {
          this.campaignAdapter.updateCBAId(this.campaignDetail.customerId, this.campaignDetail.advertiserId, this.campaignDetail.brandId);
          this.router.navigate(['campaign/edit', row.original.id]).catch((e) => {
            console.error(e);
            this.showContentLoading = false;
          });
        }
      },
      isActive: () => true
    }
  ];

  toolbarConfigs: ToolBarConfigs = {
    isSearchEnable: true
  };

  constructor(
    private campaignAdapter: CampaignAdapter,
    private router: Router
  ) { }

  ngOnInit() {
  }

  cancel() {
    this.open = false;
    this.close.emit();
  }

}
